<template>
    <div>
        <playerList :game_id="game_id"></playerList>
    </div>
</template>

<script>

import playerList from '@/components/games/player/list.vue';

export default {
    components: {
        playerList
    },
    data () {
        let self = (window.x = this)
        return {
            game_id: 1,
        }
    },
    methods: {
    },
    mounted () {
    },
    watch: {},
    computed: {}
}
</script>